import { Unit } from "uom";
import * as UnitDivide from "../unit-divide";
import { Liter, CubicMeter, Gallon, HundredCubicFeet } from "./volume";
// Per Volume
export var OnePerLiter = UnitDivide.dimensionlessByVolume("OnePerLiter", Unit.One, Liter);
export var OnePerCubicMeter = UnitDivide.dimensionlessByVolume("OnePerCubicMeter", Unit.One, CubicMeter);
export var OnePerGallon = UnitDivide.dimensionlessByVolume("OnePerGallon", Unit.One, Gallon);
export var OnePerHundredCubicFeet = UnitDivide.dimensionlessByVolume("OnePerHundredCubicFeet", Unit.One, HundredCubicFeet);
//# sourceMappingURL=dimensionless-per-volume.js.map